import React from "react";
import OnboardingDocumentDetail from "../OnboardingDocumentDetail";

interface T3ApprovedOnboardingDocumentViewProps {}

const T3ApprovedOnboardingDocumentView: React.FC<
  T3ApprovedOnboardingDocumentViewProps
> = () => {
  return (
    <>
      <OnboardingDocumentDetail isApprovedView={true} />
    </>
  );
};

export default T3ApprovedOnboardingDocumentView;
